const apiBaseUrl =
  import.meta.env.VITE_API_BASE_URL || "https://api.rhizoweb.com/api/v1"

if (!apiBaseUrl) {
  throw new Error("VITE_API_BASE_URL is not defined. Add it to your .env file.")
}

// Optional. When unset, the parcels-tab map shows a placeholder card
// instead of failing — every other traceability view still works.
const mapboxToken =
  (import.meta.env.VITE_MAPBOX_TOKEN as string | undefined) ?? ""

// Optional. When unset, the internal Transactions tab renders without
// receipt-image thumbnails (the public share view never shows them).
const r2ProxyToken =
  (import.meta.env.VITE_R2_PROXY_TOKEN as string | undefined) ?? ""

// Datadog RUM + Logs. When applicationId or clientToken is blank the
// SDK is not initialized — local dev runs without any reporting.
const datadogApplicationId =
  (import.meta.env.VITE_DATADOG_APPLICATION_ID as string | undefined) ??
  "b313520c-9d60-4c6a-abc2-189064f668a7"
const datadogClientToken =
  (import.meta.env.VITE_DATADOG_CLIENT_TOKEN as string | undefined) ??
  "pub28c740ba639984ba595d78de307226fa"
const datadogSite =
  (import.meta.env.VITE_DATADOG_SITE as string | undefined) ?? "datadoghq.eu"
const datadogService =
  (import.meta.env.VITE_DATADOG_SERVICE as string | undefined) ??
  "exporter-portal"
const datadogEnvironment =
  (import.meta.env.VITE_DATADOG_ENV as string | undefined) ??
  import.meta.env.MODE
const releaseVersion =
  (import.meta.env.VITE_RELEASE as string | undefined) ?? "0.0.1"

export const env = {
  apiBaseUrl: apiBaseUrl as string,
  mapboxToken,
  r2ProxyToken,
  datadog: {
    applicationId: datadogApplicationId,
    clientToken: datadogClientToken,
    site: datadogSite,
    service: datadogService,
    environment: datadogEnvironment,
    version: releaseVersion,
  },
} as const
